import { Card, CardContent, Grid, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useState } from "react";
import { useRef } from "react";
import React from "react";
import { useMaterialUIController } from "context";
import Quagga from "quagga";

const BardcodeScannerCard = (props) => {
  const scannerRef = useRef(null);
  const [isScanning, setIsScanning] = useState(false);
  const [uicontrol] = useMaterialUIController();

  // decide whether to stop or start the scanner
  const handleScannerClick = () => {
    if (isScanning) {
      Quagga.stop();
      setIsScanning(false);
    } else {
      startScanner();
    }
  };

  const startScanner = () => {
    setIsScanning(true);
    Quagga.init(
      {
        inputStream: {
          name: "Live",
          type: "LiveStream",
          target: scannerRef.current,
          constraints: {
            facingMode: "environment", // use the device's rear-facing camera for mobile devices
          },
        },
        decoder: {
          readers: ["ean_reader"],
        },
      },
      function (err) {
        if (err) {
          // TODO: to be handled
          console.error("Error initializing Quagga:", err);
        } else {
          Quagga.start();
        }
      }
    );

    Quagga.onDetected(handleBarcode);
  };

  const handleBarcode = (result) => {
    const code = result.codeResult.code;

    if (props.onBarcodeDetected) {
      props.onBarcodeDetected(code);
    }

    Quagga.stop();
    setIsScanning(false);
  };

  return (
    <>
      <Grid item xs={12} md={12} lg={12}>
        <MDButton
          type="button"
          fullWidth
          variant="gradient"
          color={uicontrol.sidenavColor}
          sx={{ height: "40px" }}
          onClick={handleScannerClick}
        >
          {isScanning ? "stop scanning" : "scan id card"}
        </MDButton>
        <div ref={scannerRef}></div>
      </Grid>
    </>
  );
};

export default BardcodeScannerCard;
